export default class Ball {

    name
    spot
    radius
    color
    sprite

    constructor(name, radius, color) {
        this.name = name
        this.radius = radius
        this.color = color
    }

    draw(graphics) {
        graphics.lineStyle(1, this.color, 0.5)
        graphics.fillStyle(this.color, 1)

        const circle = new Phaser.Geom.Circle(this.radius, this.radius, this.radius)

        graphics.fillCircleShape(circle)
        graphics.strokeCircleShape(circle)
        
        graphics.generateTexture(this.name, (this.radius + 1) * 2, (this.radius + 1) * 2)
    }

    destroy() {
        this.sprite.destroy()
    }
}
